<template>
  <div class="container">
    <div class="mt-3">
      <!-- View Switcher -->
      <div class="row">
        <div class="col-md-12 text-center">
          <a
            class="btn btn-link"
            :class="view == 'pad' ? 'text-success' : 'text-muted'"
            @click="toggleView('pad')"
            href="javascript: void(0);">
            Search & Add
          </a>
          <a
            class="btn btn-link"
            :class="view == 'copy&paste' ? 'text-success' : 'text-muted'"
            @click="toggleView('copy&paste')"
            href="javascript: void(0);">
            Copy & Paste
          </a>
        </div>
      </div>
      <!-- Header -->
      <div v-if="view == 'pad'">
        <div class="row d-none d-sm-block">
          <div class="col-md-12">
            <div class="text-center">
              <strong>Do you know exactly what you are looking for? </strong>
              <div class="text-muted mt-2">Enter a Product ID, UPC or Generic Search Term. Select a product from the results, then add your quantity and click "Add To Cart".</div>
            </div>
          </div>
        </div>
        <!-- Search Form -->
        <form
          name="quickPadSearch"
          @submit.prevent="submit">
          <div class="col-md-12 mt-2 animate__animated animate__fadeIn animate__faster text-center">
            <div class="btn-group text-center field-width">
              <input
                name="quickPadSearchProduct"
                id="quickPadSearch"
                class="form-control"
                type="text"
                v-model="product.query"
                autocomplete="off"
                autocapitalize="off"
                spellcheck="false"
                placeholder="Search Products...">
                <i
                  v-if="product.query"
                  class="fa fa-times text-danger clear-times"
                  @click="fastClear"/>
                <button
                  class="btn btn-primary"
                  type="submit">
                  <i class="fa fa-search"/>
                </button>
            </div>
          </div>
        </form>
        <!-- Results -->
        <div v-if="products">
          <hr
            v-if="products"
            class="mt-2">
          <div
            v-for="p in products"
            :key="p.product_id"
            class="row p-2">
            <QuickPadRow :product="p"/>
            <hr>
          </div>
        </div>
        <!-- No Result Handler -->
        <div
          v-if="!loading && products && products.length == 0"
          class="col-md-12 text-center text-muted mt-5">
          <h4>No Results</h4>
        </div>
        <!-- Spinner -->
        <div
          v-if="loading"
          class="col-md-12 text-center mt-5">
          <Spinner/>
        </div>
        <!-- Confirmation -->
        <div
          v-if="confirm"
          class="row">
          <div class="col-md-12 mt-5 text-center text-success animate__animated animate__bounceIn animate__faster">
            <h3>
              Product Added To Cart
              <i class="fa fa-check-circle"/>
            </h3>
          </div>
        </div>
      </div>
      <CopyAndPaste v-if="view == 'copy&paste'"/>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import Spinner from '../../../global/Spinner.vue'
  import CopyAndPaste from './CopyAndPaste.vue'
  import QuickPadRow from './QuickPadRow.vue'

  export default {
    data(){
      return{
        product: {
          query: '',
          qty: null
        },
        products: null,
        loading: false,
        pad: [],
        confirm: false,
        view: 'pad'
      }
    },
    components:{
      Spinner,
      CopyAndPaste,
      QuickPadRow
    },
    methods:{
      submit(){
        if(this.product.query != ''){
          this.loading = true
          this.products = null
          let params = {
            query: {
              query: this.product.query,
              action: 'quickPadSearch'
            }
          }
          document.activeElement.blur()
          axios.get('/api/v1/private/quick_pad/search', {params, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'brackets'})})
          .then(res =>{
            this.products = res.data.products
            this.loading = false
          })
          .catch(error=>{
            console.error("Error:", error);
          })
        }
      },
      fastClear(){
        this.activeProduct = null
        this.products = null
        this.product = {
          query: '',
          qty: null
        }
        const input = document.getElementById('quickPadSearch')
        input.focus()
      },
      toggleView(view){this.view = view},
    }
  }
</script>

<style scoped>
  .clear-times{
    position: absolute;
    right: 60px;
    top: 1px;
    padding: 10px;
    cursor: pointer;
  }
  @media(max-width: 575px){
    .field-width{
      min-width: 100%;
    }
  }
  @media(min-width: 576px){
    .field-width{
      min-width: 70%;
    }
  }
</style>